import { configuration } from 'src/configuration';
import Cookies from 'universal-cookie';

function verifyClientId(clientId: string) {
  if (!clientId) {
    return configuration.cognitoClientId;
  }

  return clientId;
}

function selectCookiePrefix(env: string) {
  if (env === 'prd') {
    return 'app';
  }
  if (env === 'stg') {
    return 'stg';
  }
  if (env === 'dev') {
    return 'dev';
  }

  return 'local';
}

const prefix = selectCookiePrefix(configuration.medeloopEnvironment);

export const COOKIE_KEYS = {
  AUTH: {
    SESSION: `${prefix}_session`,
  },
  CONTEXT: {
    PROJECT_CONTEXT: `${prefix}_context:project`,
    ORGANIZATION_CONTEXT: `${prefix}_context:organization`,
  },
};

const defualtUrl = configuration.appUrl;

enum SameSiteType {
  LAX = 'lax',
}

const separator = '~';

export const getCookiesDomain = function (): string {
  if (defualtUrl.includes('localhost')) {
    return 'localhost';
  }

  return defualtUrl.substring(defualtUrl.indexOf('.'));
};

// 30 days, change last number to change days
const cookiesExpire = 60 * 60 * 24 * 30;

export function getRefreshToken(): string {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && key.includes('refreshToken')) {
      return localStorage.getItem(key) || '';
    }
  }

  return '';
}

export function getIdToken(): string {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && key.includes('idToken')) {
      return localStorage.getItem(key) || '';
    }
  }

  return '';
}

export function getAccessToken(): string {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);

    if (key && key.includes('accessToken')) {
      return localStorage.getItem(key) || '';
    }
  }

  return '';
}

/*
    We need to ensure that the app can be used in dev for local development so that developers
    don't need to have this app open in localhost for authentication. Therefore, an extra param
    in dev can me given for setting cookies in local domain
*/

export function getSessionCookie() {
  const cookieOptions = {
    path: '/',
    sameSite: SameSiteType.LAX,
    domain: getCookiesDomain(),
    secure: configuration.safeCookies,
    maxAge: cookiesExpire,
  };

  const cookies = new Cookies(cookieOptions);

  const key = `${prefix}_session`;

  return cookies.get(key) || '';
}

export function setAuthCookies(clientId: string, token?: string) {
  const verfiedClientId = verifyClientId(clientId);

  const cookieOptions = {
    path: '/',
    sameSite: SameSiteType.LAX,
    domain: getCookiesDomain(),
    secure: configuration.safeCookies,
    maxAge: cookiesExpire,
  };

  const cookies = new Cookies();

  const refreshToken = token || getRefreshToken();

  const key = `${prefix}_session`;
  const combined = verfiedClientId + separator + refreshToken;
  const session = btoa(combined);

  cookies.set(key, session, cookieOptions);
  cookies.set(`${prefix}_is_coming_from_login`, 'true', cookieOptions);
}

export function removeAuthCookies() {
  const cookieOptions = {
    path: '/',
    sameSite: SameSiteType.LAX,
    domain: getCookiesDomain(),
    secure: configuration.safeCookies,
    maxAge: cookiesExpire,
  };

  const cookies = new Cookies();

  const key = `${prefix}_session`;

  cookies.remove(key, cookieOptions);
  cookies.remove(`${prefix}_is_coming_from_login`, cookieOptions);
}
